<template>
    <team-report-wrapper :loaded="loaded" :error="error" :key="loadedLanguage">
        <component :is="component" type="reportsWeb" :exposed="exposed" />
    </team-report-wrapper>
</template>
<script src="./TeamReport.ts"></script>
